import { render } from "./bar.vue?vue&type=template&id=3a49c854&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"

import "./bar.vue?vue&type=style&index=0&id=3a49c854&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a49c854"]])

export default __exports__